import {
  type IExperience,
  type IMultiExperience
} from '~/lib/ContentfulService';
import containsMatchingAudience from '~/utils/experience/containsMatchingAudience';
import { isEntryOfContentType } from '~/utils/guards/isEntryOfContentType';
import getFirstMatchingExperience from '~/utils/experience/getFirstMatchingExperience';
import { isDefined } from '~/utils/guards/isDefined';

function getContentTypesOfExperienceContent(
  item: IExperience | IMultiExperience
) {
  if (
    isEntryOfContentType(item, 'experience') &&
    containsMatchingAudience(item)
  ) {
    return (
      (item as IExperience).fields.audienceContent
        ?.filter(isDefined)
        .map((e) => e.sys.contentType.sys.id) ?? []
    );
  }

  return (
    (item as IExperience | IMultiExperience).fields.baselineContent
      ?.filter(isDefined)
      .map((e) => e.sys.contentType.sys.id) ?? []
  );
}
export default function getContentTypesFromRelevantContent(
  item: IExperience | IMultiExperience
) {
  if (isEntryOfContentType(item, 'experience')) {
    return getContentTypesOfExperienceContent(item);
  }
  if (isEntryOfContentType(item, 'multiExperience')) {
    return (() => {
      if ((item as IMultiExperience).fields.stopsAfterHit) {
        const firstMatchingExperience = getFirstMatchingExperience(item);
        return [firstMatchingExperience ?? (item as IMultiExperience)];
      }
      return (item as IMultiExperience).fields.experiences;
    })()
      .filter(isDefined)
      .map((experience) => getContentTypesOfExperienceContent(experience))
      .flat();
  }
  return [];
}
